export const sourceValues = ['技术规划', '产品需求', '临时插入', '内部管理', '其他', '客户专项']

export const sourceOptions = sourceValues.map((label, value) => ({
  label,
  value,
}))

export const sourceEnums = sourceOptions.reduce(
  (acc, v) => ({
    ...acc,
    [v.value]: v.label,
  }),
  {} as any
)
